<template>
  <div class="b1">
    <nav_list></nav_list>

    <div class="b2">
      <!-- 快速搜索 -->
      <div class="search_wd">
        <div class="search bdall">
          <div class="tit">
            <span>{{$lang(48030)}}</span>
          </div>


          <div class="v3p">
            <div class="p1">
              <div class="l1">
                <span>{{ $lang(37401) }}</span>
              </div>
              <div class="sel">
                <el-cascader class="ipt" v-model="map.start_id" :options="options" filterable @change="start_id_change">
                </el-cascader>

              </div>
            </div>

            <div class="p1">
              <div class="l1">
                <span>{{ $lang(38456) }}</span>
              </div>
              <div class="sel">
                <el-select class="ipt" v-model="map.start_region">
                  <el-option v-for="itm in start_region" :key="itm.tit" :label="itm.tit" :value="itm.id">
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>


          <!-- 逆向搜索按钮 -->
          <div class="reverse" @click="switch_se">
            <img src="/static/reverse.png" alt="">
          </div>
          <div class="v3p">
            <div class="p1">
              <div class="l1">
                <span>{{ $lang(37411) }}</span>
              </div>
              <div class="sel">
                <el-cascader class="ipt" v-model="map.end_id" :options="options" filterable @change="end_id_change">
                </el-cascader>
              </div>
            </div>


            <div class="p1 ">
              <div class="l1">
                <span>{{ $lang(38456) }} </span>
              </div>
              <div class="sel">
                <el-select class="ipt" v-model="map.end_region">
                  <el-option v-for="itm in end_region" :key="itm.tit" :label="itm.tit" :value="itm.id">
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div class="p1 p1v33">
            <div class="l1">
              <span>{{ $lang(47474) }} </span>
            </div>
            <div class="sel">
              <el-date-picker class="ipt" v-model="map.date" value-format="yyyy-MM-dd" align="right" type="date"
                :placeholder="this.$lang('37405')" :picker-options="pickerOptions"> </el-date-picker>
            </div>
          </div>
          <div class="p1">
            <div class="l1">
              <span> {{ $lang(38458) }} </span>
            </div>
            <div class="  time_division_typea">




              <el-radio-group v-model="map.time_division_type">
                <el-radio v-for="(itm, i) in tags.time_division_type" :key="i" :label="itm.id">{{ itm.title
                  }}</el-radio>

              </el-radio-group>

            </div>

          </div>

          <div class="p1">
            <div class="l1">
              <span>{{ $lang(38459) }} </span>
            </div>
            <div class="sel3">
              <div class="labe2 labe1 " v-for="(itm, i) in tags.bus_type" :key="itm.title" @click="set_bus_type(itm.id)"
                v-bind:class="{ labe_act: map.bus_type == itm.id }">
                <div class="text11">{{ itm.title }}</div>
              </div>


            </div>
          </div>
          <div class="p1">
            <div class="l1">
              <span>{{ $lang(38460) }}</span>
            </div>
            <div class="sel3">
              <div class="labe2 labe1 " v-for="(itm, i) in tags.bus_option" :key="itm.title"
                @click="inc_tag('bus_option', itm.id)" v-bind:class="{ labe_act: map.bus_option.indexOf(itm.id) > -1 }">
                <div class="text11">{{ itm.title }}</div>
              </div>
            </div>
          </div>

          <div class="btnsss">
            <el-button class="btnsss_inn" icon="el-icon-search" @click="re()">搜索</el-button>

          </div>



          <!-- <div class="p2">
          <div class="l2">
            <span>女性安心：女性单独一人预订车票的情况下，相接的座位仅安排女性同座。 女性专车：全车均为女性乘客，男性乘客不可预订。</span>
          </div>

        </div> -->
        </div>
      </div>
      <div class="b3">
        <!-- 筛选框 -->
        <div class="screen bdall">
          <div class="t1">
            <div class="p1 bty" @click="set_sorll('dec')"><i class="el-icon-arrow-left"></i>

            </div>
            <div class="dates" id="dates" ref="dates">
              <div class="ddd" v-bind:class="{ dact: map.date == itm.date }" @click="set_date(itm.date)"
                v-for="(itm, i) in dates" :key="itm.date">
                <span>{{ itm.title }}</span>

              </div>
            </div>


            <div class="p1 bty" @click="set_sorll('inc')" style=" text-align: left;"><i class="el-icon-arrow-right"></i>
            </div>
          </div>

          <div class="t22">
            <div class="p2" v-for="(itm, i) in orders" :key="itm" @click="set_order(i)"
              v-bind:class="{bl_ft : i == map.order}">


              {{itm}}
              <i class="el-icon-bottom" v-if="i == 2 || i == 4"></i>
              <i class="el-icon-top" v-else></i>

            </div>

          </div>
        </div>

        <!-- 车次列表 -->
        <div class="list  " v-loading.fullscreen.lock="is_load">
          <div class="bb1 bdall" v-for="(itm, i) in data" :key="itm.id">
            <div class="c1">
              <div class="trtagzz tag"v-for="(tag, i) in itm.tags" :key="tag.display"> {{ tt(tag.display) }} </div>
		

              

            </div>

            <div class="c2">
             
              <span class="tt"> {{ tt(itm.service_name) }}</span>
            </div>

            <div class="c3">
              <div class="rig">
                <div class="money">
                  <span>
                    <span class="money_2">{{ $lang(48468) }} </span>
                    {{ itm.show_money }}</span>
                </div>
                <el-row class="btn2">
                  <div class="yd_btn" @click="buy(itm)">
                    {{ $lang(42339) }}
                  </div>

                </el-row>
              </div>
              <div class="lef btf_soll">

                <div class="ponts">
                  <div class="bl " v-for="(pt, n) in itm.platforms.filter(p => p.platform_type === 'geton')"  :key="pt.name"
                    @click="show_point(pt)">
                    {{ tt(pt.name) }} <br>
                    {{ pt.time }}
                  </div>
                  <div class="bl yel "v-for="(pt, n) in itm.platforms.filter(p => p.platform_type === 'getout')"  :key="pt.name"
                    @click="show_point(pt)">
                    {{ tt(pt.name) }}
                    <br>
                    {{ pt.time }}
                  </div>
                </div>

              </div>

            </div>



          </div>
          <div>
            <div class="sybt" @click="get_list">

              <i class="el-icon-caret-bottom"></i>
              {{$lang(48029)}}


            </div>
          </div>
          <!-- <div style=" text-align: right;">
            <el-pagination background layout="prev, pager, next" :current-page="list.current_page"
              :page-size="list.per_page" :total="list.total" @current-change="change_page">
            </el-pagination>
          </div> -->
        </div>

        <div style="height: 60px;"></div>
      </div>
    </div>
    <point_tc :id="point_id" ref="pot_tc"> </point_tc>
  </div>
</template>

<script>

import nav_list from './nav_list.vue';
import langMixin from "../../utils/lang.js";
export default {
  name: "search",
  mixins: [langMixin],
  components: {  //注册
    nav_list,
  },
  data() {
    return {
      options: [],
      pickerOptions: {
        disabledDate(time) {
          if (time.getTime() < new Date(new Date().toLocaleDateString()).getTime()) {
            return true
          }
          if ( time.getTime() > (Date.now() +1000 * 60 *  60 * 24 * 30)) {
            return true
          }
          return false
        },


      },
      value: '',
      radio1: '全部',
      dialogFormVisible: false,
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: ''
      },
      formLabelWidth: '120px',
      active: false,
      
      map: {
					title: '', // 标题
					start_id: 0, // 出发城市ID
                    start_city_key : '',
					end_id: 0, // 到达城市ID 
                    end_city_key : '',
					start_i: 0,
					end_i: 0,
					date: '', // 日期
					start_region: 0, // 出发地区ID
					end_region: 0, // 到达地区ID
					start_region_i: 0,
					end_region_i: 0,
          start_region_key : '',
          end_region_key : '',
					time_division_type: '', // 时间段类型
					bus_type: '', // 巴士类型
					bus_option: [], // 巴士选项
					bus_option22: [], // 巴士选项
          cdd : '',
					order: 0 // 排序方式
				},
      orders : [ ],
      dates: [],
      tags: {},
      start_region: [],
      end_region: [],
      list : [],
      data : [],
      page : 1,
      is_load : false,
      point_id : 0,
      req_num : 0,
      com : {},
      com_fit:[],
				conf : {},
				rate : 1,
        cut_date: [],
        cut_sn : [],
    };
  },

  mounted() {
    let home_map = this.cache('home_map')
    if (home_map) {
      console.log(home_map)
      this.map.start_id = home_map.start_id
      this.map.end_id = home_map.end_id
      this.map.start_city_key = home_map.start_city_key
      this.map.end_city_key = home_map.end_city_key
      this.map.time_division_type = home_map.time_division_type
      this.map.date = home_map.date
      this.map.bus_type = home_map.bus_type
      // this.cache('home_map', '')
    }

    if (this.cache('list_map')) {

      this.map = this.cache('list_map')

    }
    console.log('xxxx',this.$route.query)
 
    if ('start_city_key' in this.$route.query && 'end_city_key' in this.$route.query ) {
					      this.map = this.$route.query
					      delete this.map.lang
					      if (this.map.bus_option == '') {
					        this.map.bus_option = []
					      } else {
					        this.map.bus_option = this.map.bus_option.split(',')
					        for (let i in this.map.bus_option) {
					          this.map.bus_option[i] = this.map.bus_option[i]
					        }
					      }
					      this.map.start_id = parseInt(this.map.start_id)
					      this.map.start_city_key = this.map.start_city_key
					      this.map.end_city_key = this.map.end_city_key
						   
					      if ('start_region' in this.$route.query ) this.map.start_region = parseInt(this.map.start_region)
					      if ('end_region' in this.$route.query)  this.map.end_region = parseInt(this.map.end_region)
					      this.map.end_id = parseInt(this.map.end_id)
					 
					      if ('time_division_type' in this.$route.query && this.$route.query.time_division_type && this.$route.query.time_division_type != 0)  this.map.time_division_type = this.$route.query.time_division_type
					      if ('bus_type' in this.$route.query && this.$route.query.bus_type && this.$route.query.bus_type != 0)  this.map.bus_type = this.$route.query.bus_type
					      if ('cdd' in this.$route.query && this.$route.query.cdd && this.$route.query.cdd != 0)  { 
                  this.map.cdd = this.$route.query.cdd
                  alert(2)
                }
					
      }
				 
				 
		 

    this.filter();
    this.start_id_change();
    this.end_id_change();

  },
  methods: {
    show_point(id) {
      // alert(id)
      this.point_id = id
      this.$refs.pot_tc.f5(id)
    },
    buy(id){
     
      this.cache('hot_source', 'bushikaku')
      this.cache('hot_vo', id)
      this.jump('/hot/pre_order')
    },
    re() {
      this.data = []
      this.page = 1
      this.get_list()
    },
    change_page(e) {
      this.page = e
      this.get_list()
    },
    get_list() {
      if (this.cut_date.length > 0) {
					// this.map.date = 
					if (this.cut_date.indexOf(this.map.date) !== -1) {
						return false
					}

				}
      document.title = this.$lang(51615) +  '-' + this.web_tit;
      this.is_load = true
      this.cache('list_map', this.map)

      let url = 'https://api.japanbus.cn/getbus/api/v1/search_buses/'
                let params = {
                    from_pref: this.map.start_city_key,
                    to_pref: this.map.end_city_key,
                    date: this.map.date.replace(/-/g, '')
                }
                console.log('this.map.start_region_key',this.map.start_region_key)
                if (this.map.start_region) {
                    params.from_area = this.map.start_region
                }
                if (this.map.end_region) {
                    params.to_area = this.map.end_region
                }
                if (this.map.time_division_type && this.map.time_division_type != 0) {
                    params.time_division = this.map.time_division_type
                }
                if (this.map.bus_type && this.map.bus_type != 0) {
                    params.bus_type = this.map.bus_type
                }
                if (this.map.bus_option && this.map.bus_option.length > 0) {
                    params.bus_option = this.map.bus_option.join(',')
                }
                if (this.map.cdd && this.map.cdd != '' ) {
                  alert(this.map.cdd)
                    params.bus_co_code =  this.map.cdd
                }
                if (this.map.bus_option22 && this.map.bus_option22.length > 0) {
                   
                    let  bus_option22 = this.map.bus_option22.join(',')
                    if(params.bus_option != '') {
                        params.bus_option += ',' + bus_option22
                    } else {
                        params.bus_option = bus_option22
                    }
                }
            
                if (this.page > 1) {    
                    params.page = this.page
                }
                let orders  = ['', 'outgo', 'r,outgo'];
                if (this.map.order > 0) {
                    params.order = orders[this.map.order]
                }
                        
              this.$axios.request({
                url: url,
               
                method: 'get',
                params: params,
              }).then((e) => {
                  const cleanedData = e.data.data.filter(item => item.attributes.promotion_bus === null).map(item => ({
                        id: item.id,
                        service_name: item.attributes.service_name || '',
                        bus_co_name: item.attributes.bus_co_name || '',
                        bus_code: item.attributes.bus_code || '',
                        bus_link: item.attributes.bus_link || '',
                        date_param: item.attributes.date_param || '',
                        seat_type: item.attributes.seat_type ? {
                            display: item.attributes.seat_type.display || ''
                        } : null,
                        time_division_type: item.attributes.time_division_type ? {
                            display: item.attributes.time_division_type.display || ''
                        } : null,
                        link : '',
                        fee: item.attributes.fee_structures,
                        money: item.attributes.fee_structures.length ?   Math.max(...item.attributes.fee_structures.filter(fs => fs.left_seat >= 5).map(fs => parseFloat( fs.amount_max || 0) || 0))
                             : 0,
                        platforms: (item.attributes.platforms || []).map(platform => ({
                            id: platform.id,
                            key: platform.platform_id_has_lat_lng || 0,
                            name: platform.name || '',
                            time: platform.time || '',
                            platform_type: platform.platform_type || ''
                        })),
                        bus_option: item.attributes.bus_option || [],
                        tags: [
                            item.attributes.seat_type ? {
                                display: item.attributes.seat_type.display || '',
                                key:  item.attributes.seat_type.bus_type || '',
                                type: 'seat'
                            } : null,
                            item.attributes.time_division_type ? {
                                display: item.attributes.time_division_type.display || '',
                                key:  item.attributes.time_division_type.name || '' ,
                                type: 'time'
                            } : null,
                            ...(item.attributes.bus_option || []).filter(option => !['子供割引', '学生割引', '座席指定', '消灯後スマホ利用可'].includes(option.display)).map(option => (
								        {
                                    display: option.display || '',
                                    key: option.name || '',
                                    type: 'option'
                                }))
                        ].filter(tag => tag !== null)
                    }));
                    for (let vo of cleanedData) {
                      let l = vo.bus_link.split('/')
                      let sn = l[1]
                      if (this.cut_sn.indexOf(sn) !== -1) {
                        continue
                      }
                      if (this.com_fit.indexOf(vo.bus_co_name) !== -1) {
                        continue
                      }
                      // 检查今天最早的出发时间
                      if (!this.isEarlyGetonTimeValid(vo.platforms)) {
                        continue
                      }
                      
                          if (vo.money > 0) {
                            vo = this.hand_money(vo)
                          this.push_v4_sreach_jp(vo)
                                        this.data.push(vo)
                          }
							
                    }
                    this.page++
                    this.get_cn()
                    this.is_load = false
                    let queryString = new URLSearchParams(Object.entries(this.map)).toString() + "&lang=" + this.cache('lang_config')
				 
						window.history.replaceState(null, 0, '/search?' + queryString)
						
                    
              })
    },
    isEarlyGetonTimeValid(platforms) {
				const today = new Date();
				const todayStr = today.toISOString().split('T')[0]; // YYYY-MM-DD

				// 检查当前选择的日期是否是今天
				if (this.map.date !== todayStr) {
					return true; // 不是今天，不过滤
				}

				// 获取所有出发点
				const getonPlatforms = platforms.filter(p => p.platform_type === 'geton');
				if (getonPlatforms.length === 0) {
					return true; // 没有出发点，不过滤
				}

				// 找最早的时间
				const parseMinutes = (time) => {
					const [h, m] = time.split(':').map(Number);
					return h * 60 + m;
				};

				let earliestMinutes = Infinity;
				for (const p of getonPlatforms) {
					if (p.time) {
						const minutes = parseMinutes(p.time);
						if (minutes < earliestMinutes) {
							earliestMinutes = minutes;
						}
					}
				}

				if (earliestMinutes === Infinity) {
					return true; // 没有有效时间，不过滤
				}

				// 计算当前时间 + today_fit_h 小时
				const now = new Date();
				const nowMinutes = now.getHours() * 60 + now.getMinutes();
				const fitHours = parseInt(this.conf.today_fit_h || '2');
				const cutoffMinutes = nowMinutes + (fitHours * 60);

				// 如果最早时间小于截止时间，说明车次已经来不及预订
				return earliestMinutes >= cutoffMinutes;
			},
    hand_money(vo) {
				let child = 0
				let man = 0
        for (let fee of vo.fee) {
					if (fee.amount_max == vo.money) {
						vo.link = fee.fs_external_link_url
						 
					}
				}

				if (vo.bus_co_name in this.com) {
					
					man = vo.money *  parseInt(this.com[vo.bus_co_name].man_dis) /100 + parseInt(this.com[vo.bus_co_name].man_inc)
					if (this.com[vo.bus_co_name].children_dis > 0) {
						child =vo.money * parseInt(this.com[vo.bus_co_name].children_dis)/100 + parseInt(this.com[vo.bus_co_name].children_inc)
					} else {
						child = man
					}
					
				} else {
					man = vo.money *  parseInt(this.conf.man_dis) /100 + parseInt(this.conf.man_inc)
					child = man
				}
				vo.show_money  = man
				if (this.cache('lang_config') == 'cn') {
					vo.show_money = vo.show_money / parseFloat(this.rate)
					// man =  man / parseFloat(this.rate)
					// child = child / parseFloat(this.rate)
				}
				vo.org_money = vo.money
				vo.show_money = this.decimal(vo.show_money,2)
				vo.man_money = this.decimal(man,2)
				vo.child_money = this.decimal(child,2)
				 
        vo.start_city_key = this.map.start_city_key
				vo.end_city_key = this.map.end_city_key
        
				vo.date = this.map.date
				return vo
				// vo.money = parseFloat(vo.money).decimal(2)
			},
    am_sorll() {

    },
    set_bus_type(id){
      this.map.bus_type = this.map.bus_type == id ? 0 : id
    },
    set_sorll(t) {
      let v = 1
      if (t == 'dec') {
        v = -1
      }
      console.log(this.$refs['dates'])
      for(let i = 0; i <= 50; i ++) {
        this.$refs['dates'].scrollLeft += v
      }

    },
    set_sorll_pls() {
      var div = document.getElementById("dates");
      var w = div.offsetWidth;    // 返回元素的总宽度
      var h = div.offsetHeight;    // 返回元素的总高度
      let n = 0
      for (let i in this.dates) {

        if (this.map.date == this.dates[i].date) {
          break;
        }
        n += 1
      }
      n-= 3
      if (n <= 0) n = 0
      w = w / 7 * n

      this.$refs['dates'].scrollLeft = parseInt(w)
    },
    set_date(d) {
      this.map.date = d
      this.set_sorll_pls()
      this.re()
    },
    set_order(d) {
      this.map.order = d
      this.re()
    },
    inc_tag(type, id) {
      let i = this.map[type].indexOf(id)
      if (i == -1) {
        this.map[type].push(id)
      } else {
        this.map[type].splice(i, 1)
      }
    },
    start_id_change(e) {
      if (e) {
        this.map.start_id = e[0]
      }

      let city_id = this.map.start_id
      if (!city_id) {
        return
      }
      this.options.map((item) => {
        if (item.value == e[0]) {
           this.map.start_city_key = item.key
        }
      })
      this.get("/v4/train_area", { id: city_id }).then((e) => {
        this.start_region = e.list;
        this.map.start_region = 0
      });

    },
    end_id_change(e) {
      if (e) {
        this.map.end_id = e[0]

      }

      let city_id = this.map.end_id
      if (!city_id) {
        return
      }
      this.options.map((item) => {
        if (item.value == e[0]) {
           this.map.start_end_key = item.key
        }
      })
      this.get("/v4/train_area", { id: city_id }).then((e) => {
        this.end_region = e.list;
        this.map.end_region = 0
      });

    },
    switch_se() {
      let temp = this.map.start_id
      this.map.start_id = this.map.end_id
      this.map.end_id = temp
      temp = this.map.start_city_key
      this.map.start_city_key = this.map.end_city_key
      this.map.end_city_key = temp
      temp = this.map.start_region
      this.map.start_region = this.map.end_region
      this.map.end_region = temp

      temp = [...this.start_region]
      this.start_region = [...this.end_region]
      this.end_region = [...temp]


    },
    filter() {
      this.get("/index/sreach_filter_v4").then((e) => {
        this.options = e.list;
        this.tags = e.tags
        this.dates = e.dates
        this.orders = e.orders
        this.com = e.com
        this.com_fit = e.com_fit
					this.conf = e.conf
          this.rate = e.rate
          if (this.conf.cutdate) {
						this.cut_date = this.conf.cutdate.split('|')
					}
					if (this.conf.cut_sn) {
						this.cut_sn = this.conf.cutsn.split('|')
					}
          
        this.get_list()
      });
    },
    city() {
      // this.get("/search/index?lang="+this.cache('lang_config'), {start_id : this.map.set_out[1],end_id : this.map.destination[1]}).then((e) => {
      //     this.options = e.city;
      // });
    },

  },


};
</script>


<style   scoped>
.sybt {
  cursor: pointer;
		text-align: center;

		color:#c7c7c7;

    margin-top: 80px;
		/*定位横线（当横线的父元素）*/
		display: block;
  height: 50px;
  line-height: 50px;
  border:  1px solid #c7c7c7;
  border-radius: 10px;
		/*设置为块级元素会独占一行形成上下居中的效果*/
	}
</style>

<style scoped>
.ipt {
  width: 99% !important;
}
.b1 {
  display: flex;
  flex-direction: column;

}

.b2 {
  margin-top: 25px;
  display: flex;
}

/* 蓝色筛选块 */
.labe1 {
  background-color: #fff;
  color: #606266 ;
  border: 1px solid #c7c7c7;
}

.labe3 {
  background-color: #50A2F8;
}

/* 灰色筛选块 */
.labe2 {

  height: 36px;
  line-height: 36px;
  border-radius: 4px;
  margin-right: 1%;
  margin-top: 1%;
  flex: 0 0 28%;
  padding: 0px 4px;
  white-space: nowrap;
  overflow: hidden;
  text-align: center;
  cursor: pointer;
}

.labe_act {
  background: #50A2F8;
  color: #fff;
}

/* 筛选块中文字 灰色 */
.text11 {

  font-family: Noto Sans SC;
  font-size: 13px;
  font-weight: 400;

  letter-spacing: 0%;
  text-align: center;
}

/* 筛选块中文字 蓝色 */
.text22 {
  font-family: Noto Sans SC;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  text-align: center;
  margin-top: 13%;
}

/deep/ .time_division_typea .el-radio {
 margin-right: 10px;
}
/deep/ .time_division_typea .el-radio__label {
padding-left: 2px;
}


/* 快捷搜索 */
.search_wd {
margin-left: 1%;
  flex: 0 0 20%;
}
.btnsss {
  text-align: center;
}
.btnsss_inn {
  background-color: rgba(80, 162, 248, 1);
    color: rgba(255, 255, 255, 1);

    box-shadow: 0px 2px 6px 0px rgba(57, 90, 246, 0.5);
    width: 70%;
    border:0px;
}
.search {
  padding-bottom:10px;
  box-sizing: border-box;
  background: rgb(255, 255, 255);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  margin-bottom: 3%;
  font-size: 14px;
}

.tit {
  width: 100%;
  height: 56px;
  line-height: 56px;
  background: #50A2F8;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;

}

.tit span {
  margin: 0 auto;
  display: flex;
  width: 72px;
  color: rgb(255, 255, 255);
  font-family: Noto Sans SC;
  font-size: 18px;
  font-weight: bold;
}

.search .v3p {
  display: flex;
  justify-content: space-between;
  width: 94%;
  margin: 0px auto;
}
.search .v3p .p1 {
  flex: 0 0 46%;
  padding: 10px 5px;
  background-color: rgba(248, 248, 248, 1);
  display: block;
}
.search .v3p .p1 .l1 {
  font-weight: normal;
}
.search .p1 {
 border-radius: 5px;
    width: 94%;
  margin: 5px auto;
  padding: 10px 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;

}
.p1v33 {
  display: block !important;
  background-color: rgba(248, 248, 248, 1);
  width: 90% !important;
}

/deep/ .p1v33 .el-input__inner {

  font-weight: normal !important;

}

.search .p1 .l1 {
 font-weight: bold;
 flex:  0 0 25%;
}

.search .p1 .sel {

 flex:  0 0 75%;
 word-spacing: nowap;
}

/deep/ .search .p1 .sel .el-input__inner{
border:1px solid rgba(248, 248, 248, 1);;
font-weight: bold;
color: #000;
background-color: rgba(248, 248, 248, 1);
}

.search .reverse {
  margin: 0 auto;

}

.search .reverse .text1 {

  color: rgb(255, 255, 255);
  font-family: Noto Sans SC;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  text-align: center;

}

.search .p1 .sel2 {

  margin-right: 20.5%;
  width: 202px;
}

.search .p1 .sel2 .sel2_radio {
  display: flex;
}

.search .p1 .sel3 {

  min-width: 202px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-items: center;
}

.search .p2 {

  display: flex;
  margin: 0 auto;
  margin-top: 10%;

}

.search .p2 .l2 {

  width: 289px;
  background: rgb(222, 235, 249);

}

.search .p2 .l2 span {
  font-family: Noto Sans SC;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;

  color: rgb(67, 108, 157);
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 14px 20px 14px 20px;

}

/* 筛选 */

.b3 {
  width: 75vw;
}

.screen {

  margin-right: 5%;
  margin-left: 1%;

  box-sizing: border-box;
  background: rgb(255, 255, 255);

  border-radius: 10px;
    font-size: 14px;
}

.screen .t1 {
  -moz-user-select: none;
  /*火狐*/

  -webkit-user-select: none;
  /*webkit浏览器*/

  -ms-user-select: none;
  /*IE10*/

  -khtml-user-select: none;
  /*早期浏览器*/

  user-select: none;
  display: flex;
  margin: 0 auto;
  width: 100%;
  overflow-y: hidden;
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #c7c7c7;

}

.screen .bty {
  flex: 0 0 10%;
  text-align: center;
  cursor: pointer;
}

.screen .dates {
  display: flex;

  flex: 0 0 80%;
  overflow-x: scroll;
  -ms-overflow-style: none;
  overflow: -moz-scrollbars-none;
align-items: center;
}


.screen .dates .ddd {
  cursor: pointer;
  flex: 0 0 13%;
  border-left: 1px solid #c7c7c7;
    height: 30px;
      line-height: 30px;
      text-align: center;

}

.screen .dates .dact {
  color: #2063FF;
  font-weight: bold;
}

.screen .dates::-webkit-scrollbar {
  width: 0 !important;
  height: 0 !important;
}


.screen .t1 .p1 span {
  margin: 0 auto;
  color: rgb(33, 37, 41);
  font-family: Noto Sans SC;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0%;
  text-align: left;
}

.screen .hor_line {
  width: 90%;
  margin: 0 auto;
}

.screen .t22 {
  display: flex;
  margin: 0 auto;
  width: 80%;
}

.screen .t22 .p2 {
  display: flex;
  margin: 0 auto;
  flex: 0 0 25%;
  height: 53px;
  cursor: pointer;

  align-items: center;
}


.screen .t22 .p2 span {
  /* border: 1px solid #eee; */
  height: 30px;
line-height: 30px;
  width: 60px;
  text-align: center;
  display: inline-block;
}


/* 数据 */
.list {
  margin-top: 1%;
  margin-left: 1%;
  width: 94%;
  box-sizing: border-box;
  background: #fff;


  border-radius: 10px;
  display: flex;
  flex-direction: column;
}

.list .bb1 {
  border-radius: 10px;
  margin-top: 10px;
  padding: 20px;
}

.list .c1 {
  width: 100%;
  display: flex;
}

.list .c1 .tag {

  border-radius: 4px;
  margin-right: 2%;

  height: 27px;
  line-height: 27px;
  font-size: 12px;
  padding:  0 10px;
  border-radius: 5px;
    background-color: rgba(239, 239, 239, 1);
    color: #6C6C6C;

    text-align: center;

}


.bl_ft {
  color :#175EFF;
}
.ponts {
  display: flex;
  align-items: center;

  width: 100%;
  text-align: center;
  font-weight: bold;
}
.bl {
  padding: 10px 10px;
  box-sizing: border-box;
  background: #E8F3FF;
  border-radius: 5px;
  color: #175EFF;
  margin-right: 10px;
  font-size: 14px;
  min-width: 140px;

  white-space: nowrap;
  text-overflow: ellipsis;

}

.yel {

  background: #FFF7E9;
  color: #FE7D00;
}

.list .c2 {
  margin-top: 2%;
  width: 100%;
  color: rgb(0, 0, 0);
  font-family: Noto Sans SC;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 0%;
  text-align: left;
}

.list .c3 {
  margin-top: 2%;

  flex-direction: row;
    justify-content: space-between;
}

.list .c3 .lef {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-items: center;
  height: 100px;
  margin-right: 3%;

}




.list .c3 .rig {

  box-sizing: border-box;
  /* background: rgb(255, 242, 242); */
  border-radius: 4px;
  display: flex;
    /* border: 1px solid rgb(255, 228, 228); */
    align-items: center;
    justify-content: flex-end;
}

.list .c3 .rig .money_2 {
font-size: 16px;
}
.list .c3 .rig .money {
  color: #2063FF;
  font-family: Noto Sans SC;
  font-size: 22px;
  font-weight: bold;
  letter-spacing: 0%;

  margin-right: 2%;
  height: 39px;
  line-height: 39px;
  text-align: center;
}

.list .c3 .rig .btn2 {
  flex: 0 0 10%;


}

.list .c3 .rig .yd_btn {
  height: 39px;
  line-height: 39px;
  width: 90px;
  border-radius: 25px;

  font-size: 18px;
  /* background: linear-gradient(rgba(255, 121, 0, 255) 0%, rgba(255, 163, 9, 255) 100%); */
  background: #2063FF;
  color: rgb(255, 255, 255);
  box-shadow: 0px 0px 6px 0px rgba(57, 90, 246, 0.4);


    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/search_v4.vue